import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import './styles.css';

import { Box, TextField, Typography, Card, CardContent, Button, Link } from '@mui/material';

import { useAuth } from './AuthContext';

const Login = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [loadingToken, setLoadingToken] = useState(false);
  const [authToken, setAuthToken] = useState('');
  const [message, setMessage] = useState('You will be automatically signed out after 60 mins of inactivity.');
  const [step, setStep] = useState('request'); // 'request' or 'login'
  const navigate = useNavigate();
  const serverHost = process.env.REACT_APP_BACKEND_SERVER_HOST || 'https://localhost:3001';

  const handleRequestToken = async (e) => {
    setLoadingEmail(true);
    e.preventDefault();
    try {
      const response = await axios.post(`${serverHost}/requestlogin`, { email }, { withCredentials: true });
      if (response.status === 200) {
        setMessage('Please check your previously registered email account for the single use authorization token and enter in the provided field above.');
        setStep('login');
      } else {
        setMessage('Error requesting login token.');
      }
    } catch (error) {
      console.error('Request login token failed:', error.response?.data || error.message);
      setMessage(`Error requesting login token: ${error.response?.data || error.message}`);
      setLoadingEmail(false);
    }
  };

  const handleLogin = async (e) => {
    setLoadingToken(true);
    e.preventDefault();
    try {
      const loginResponse = await axios.post(`${serverHost}/login`, { email, auth_token: authToken }, { withCredentials: true });
      if (loginResponse.status === 200 && loginResponse.data.user) {
        setMessage('');
        login(loginResponse.data.user);
        navigate('/');
        return;
      }

      setMessage('Unable to login.');
    } catch (error) {
      console.error('Login failed:', error.response?.data || error.message);
      setMessage(`Error unable to login: ${error.response?.data || error.message}`);
      setLoadingToken(false);
    }
  };

  return (
    <Box className='login-container'>   
      <Card className='login-card-size'>
          <CardContent sx={{textAlign: 'center'}}>
              <img src="../../images/MdTF_Logo_Monitor.jpg" className='login-header-image' alt="logo"/>
              <Typography color="#283B42" className='login-header'>WARNING</Typography>
              <Box className='login-text'>
                <Typography color="#283B42" className='login-p1'>
                  Use of this interface is restricted to approved users for the sole purpose of supporting U.S. Government testing and evaluation (T&E) activities.  
                </Typography>
                <Typography color="#283B42" className='login-p2'>
                  By using this interface, you are acknowledging that you are authorized to submit your organization's data and/or technology for T&E activities performed by the SAIC 
                  Identity and Data Sciences Laboratory in support of the DHS Science and Technology Directorate.  All work on this system may be monitored.
                </Typography>
              </Box>
              <Box className='login-box'>
                {step === 'request' && (
                  <Box className='email-box'>
                    <Typography color="fontTheme" className='email-box-header'>
                      Email
                    </Typography>
                    <TextField 
                            id="outlined-required"
                            placeholder="Enter previously registered email"
                            onChange={(e) => setEmail(e.target.value)} 
                            disabled={loadingEmail}/>
                
                    <Button type="submit" 
                            onClick={handleRequestToken} 
                            variant="contained"
                            className='login-button'
                            disabled={loadingEmail}>
                      Login
                    </Button>
                    {message &&
                      <Box sx={{height: '80px'}}>
                        <Typography color="#283B42" className='login-message1'>
                          {message}
                        </Typography>
                      </Box>
                    }
                  </Box>
                )}
                {step === 'login' && (
                  <Box className='email-box'>
                    <Typography color="fontTheme" className='email-box-header'>
                      Authorization Token
                    </Typography>
                    <TextField 
                            id="outlined-required"
                            placeholder="Enter authorization token here"
                            onChange={(e) => setAuthToken(e.target.value)} 
                            disabled={loadingToken}/>
                
                    <Button type="submit" 
                            onClick={handleLogin} 
                            variant="contained"
                            className='login-button'
                            disabled={loadingToken}>
                      Login
                    </Button>
                    {message &&
                      <Box sx={{height: '80px'}}>
                        <Typography color="#283B42" className='login-message1'>
                          {message}
                        </Typography>
                        <Typography color="#283B42" className='login-message2'>
                          Only registered email accounts will receive an authorization token.
                        </Typography>
                      </Box>
                    }
                  </Box>
                )}
              </Box>
              <Box>
                <Typography color="#283B42" className='footer-header'>
                  POWERED BY
                </Typography>
                <img src="../../images/idsl-logo.png" alt="IDSL Logo" className='footer-image'/>
              </Box>
          </CardContent>
      </Card>
    </Box>
  );
}

export default Login;
